import {
  Box,
  Button,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import React, { useEffect, useMemo, useState } from 'react';
import { WASHUB_CONSTANTS } from '../../../shared/Constants';
import { TrollyOrderDetails } from '../model/makeData';
import { useAPI } from '../../../shared/services/api/API';
declare const qz: any;
export const TrollyOrdersList = () => {
  const { httpGet, httpPost, handleAlertBar } = useAPI();
  const [businessStoreId, setBusinessStoreId] = useState('');
  const [businessStoreData, setBusinessStoreData] = useState<any>([]);
  const [tableData, setTableData] = useState<TrollyOrderDetails[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const queryParams = {
    page: 0,
    size: 10000,
    sortColumn: 'modifiedAt',
    isDescending: true,
  };

  // GET with API : BUSINESSSTORE
  const fetchBusinessStore = async () => {
    httpGet(
      `${WASHUB_CONSTANTS.API_URLS.BUSINESS_STORE_ADMIN_BUSINESS_DATA_GET}`,
      queryParams,
    ).then((response) => {
      if (response.status === 200) {
        const sortBusinessStoreArray = response?.data?.sort((a: any, b: any) =>
          a?.name.toLowerCase().localeCompare(b.name.toLowerCase()),
        );
        setBusinessStoreData(sortBusinessStoreArray);
      } else {
        if (response.data.error) {
          console.error(
            'Error fetching BusinessStore: ',
            response.data.message,
          );
        }
      }
    });
  };

  // GET with API
  const fetchTrollyOrders = async (businessStoreId: string) => {
    setIsLoading(true);
    httpGet(
      `${WASHUB_CONSTANTS.API_URLS.TROLLY_ORDER_GET}/${businessStoreId}`,
    ).then((response: any) => {
      if (response.status === 200) {
        setTableData((): any => response?.data);
        setIsLoading(false);
      } else {
        if (response.data.error) {
          console.error('Error fetching serviceitem: ', response.data.message);
          setTableData([]);
          setIsLoading(false);
        }
      }
    });
  };

  // GET with API
  const deleteTrollyOrders = async (trollyOrderId: string) => {
    setIsLoading(true);
    httpPost(
      `${WASHUB_CONSTANTS.API_URLS.TROLLY_ORDER_DELETE_POST}/${trollyOrderId}`,
      null,
    ).then((response: any) => {
      if (response.status === 200) {
        fetchTrollyOrders(businessStoreId);
        handleAlertBar('success', 'Trolly Order deleted successfully');
        setIsLoading(false);
      } else {
        if (response.data.error) {
          console.error('Error fetching serviceitem: ', response.data.message);
          setTableData([]);
          setIsLoading(false);
        }
      }
    });
  };

  const columns = useMemo<MRT_ColumnDef<TrollyOrderDetails>[]>(
    () => [
      {
        accessorKey: 'orderDate',
        header: 'Order Date',
        size: 10,
      },
      {
        accessorKey: 'orderStatus',
        header: 'Status',
        size: 20,
      },
      {
        accessorKey: 'packageOrderId',
        header: 'Package Order Id',
        size: 20,
      },
      {
        accessorKey: 'totalItemCount',
        header: 'Item Count',
        size: 10,
      },
      {
        accessorKey: 'trollyId',
        header: 'Trolly Id',
        size: 10,
      },
    ],
    [],
  );

  const printLabel = async (printerName: string, printerLabel: any) => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
      }
      let printer = "";
      //If printerName is null, it will use default printer
      if (!printerName) {
        printer = await qz.printers.getDefault();
      } else {
        printer = await qz.printers.find(printerName);
      }
      const config = qz.configs.create(printer);
      for (const label of printerLabel) {
        let data = [];
        if (printerName === "Epson") {
          data = [
            {
              type: "raw",
              format: "command",
              flavor: "base64",
              data: label,
            },
          ];
        } else {
          data = [label];
        }
        await qz.print(config, data);
      }
      handleAlertBar("success", "Labels print successfully");
    } catch (error) {
      alert("Error: " + error);
    }
  };

  const fetchPrintBatch = (row: TrollyOrderDetails) => {
    const reqBody = {
      trollyId: row?.trollyId,
      packageOrderId: row?.packageOrderId,
      orderId: row?.orderId,
    };
    httpPost(
      `${WASHUB_CONSTANTS.API_URLS.TROLLY_PRINT_DISPATCH_POST}`,
      reqBody,
    ).then((response) => {
      if (response.status === 200) {
        try {
          if (response?.data?.label?.length > 0) {
            printLabel('', response?.data?.label)
          }
          if (response?.data?.epsonLabel?.length > 0) {
            printLabel('Epson',response?.data?.epsonLabel);
          }
        } catch (error: any) {
          throw new Error('Error fetching Print label: ', error);
        }
        fetchTrollyOrders(businessStoreId);
      } else {
        if (response.data.error) {
          console.error('Error fetching Print label: ', response.data.message);
        }
      }
    });
  };

  const fetchRePrintBatch = (row: TrollyOrderDetails) => {
    const reqBody = {
      trollyId: row?.trollyId,
      packageOrderId: row?.packageOrderId,
      orderId: row?.orderId,
      //trollyDeliveryOrderId: row?.trollyDeliveryOrderId
    };
    httpPost(
      `${WASHUB_CONSTANTS.API_URLS.TROLLY_RE_PRINT_BATCH_POST}`,
      reqBody,
    ).then((response) => {
      if (response.status === 200) {
        try {
          if (response?.data?.label?.length > 0) {
            printLabel('', response?.data?.label);
          }
          if (response?.data?.epsonLabel?.length > 0) {
            printLabel('Epson',response?.data?.epsonLabel);
          }
        } catch (error: any) {
          throw new Error('Error fetching Print label: ', error);
        }
      } else {
        if (response.data.error) {
          console.error('Error fetching Print label: ', response.data.message);
        }
      }
    });
  };

  useEffect(() => {
    fetchBusinessStore();
  }, []);

  useEffect(() => {
    if (businessStoreId) {
      fetchTrollyOrders(businessStoreId);
    }
  }, [businessStoreId]);

  return (
    <div className="mt-2">
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          padding: '2px 15px',
          minWidth: { xs: '300px', sm: '360px', md: '400px' },
          gap: '1rem',
        }}
      >
        <TextField
          size="small"
          style={{ width: '30%' }}
          key="businessStoreId"
          label="Select Business Store"
          name="businessStoreId"
          select
          onChange={(e) => {
            setBusinessStoreId(e.target.value);
          }}
          value={businessStoreId}
        >
          {businessStoreData.map((option: any) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
      <div style={{ padding: '5px 15px' }}>
        <MaterialReactTable
          defaultColumn={{
            maxSize: 150,
            minSize: 10,
            size: 50,
          }}
          displayColumnDefOptions={{
            'mrt-row-actions': {
              muiTableHeadCellProps: {
                align: 'center',
              },
              size: 120,
            },
          }}
          muiTablePaperProps={{
            sx: {
              width: '100%',
              '& .css-1tbggly': {
                minHeight: '2px',
              },
            },
          }}
          columns={columns}
          enableFullScreenToggle={false}
          enableStickyHeader
          positionActionsColumn="last"
          enableRowActions
          enableColumnActions={false}
          enableColumnFilters={false}
          enableFilters={true}
          enableSorting={false}
          enableHiding={false}
          enableDensityToggle={false}
          enableToolbarInternalActions={false}
          data={tableData}
          state={{ isLoading: isLoading }}
          editDisplayMode="modal"
          muiTableContainerProps={{
            sx: {
              height: 'auto',
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box>
              {row?.original?.orderStatus === 'TROLLY_DISPATCHED' && (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    className="ps-1 pe-1"
                    variant="contained"
                    sx={{ color: 'white' }}
                    onClick={() => {
                        fetchRePrintBatch(row.original);
                    }}
                  >
                    <Typography variant="labelNormal">
                      Re Print Batch
                    </Typography>
                  </Button>
                </Box>
              )}
              {row?.original?.orderStatus === 'TROLLY_INPACKAGING' && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '1rem',
                  }}
                >
                  <Button
                    className="ps-1 pe-1"
                    variant="contained"
                    sx={{ color: 'white' }}
                    onClick={() => {
                      deleteTrollyOrders(row.original.packageOrderId);
                    }}
                  >
                    <Typography variant="labelNormal">Delete</Typography>
                  </Button>
                  <Button
                    className="ps-1 pe-1"
                    variant="contained"
                    sx={{ color: 'white' }}
                    onClick={() => fetchPrintBatch(row.original)}
                  >
                    <Typography variant="labelNormal">
                      Print Batch Label
                    </Typography>
                  </Button>
                </Box>
              )}
            </Box>
          )}
        />
      </div>
    </div>
  );
};
